import styled from 'styled-components';
import { color } from 'theme';

export const StyledFaqsWrapper = styled.div`
  background-color: ${color('white')};
`;
